module.exports = "<app-attraction-form (submitAttraction)=\"onSubmitAttraction($event)\"></app-attraction-form>\n"